import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { InteriorSidebar } from './InteriorSidebar';
import { InteriorTopBar } from './InteriorTopBar';
import { InteriorBottomBar } from './InteriorBottomBar';
import { OptionsGallery } from './OptionsGallery';
import { SettingsMenu } from './SettingsMenu';
import { RoomsMenu } from './RoomsMenu';
import { InteriorFloatingControls } from './InteriorFloatingControls';
import { SelectionsProvider } from './SelectionsContext';
import { SelectionsWidget } from './SelectionsWidget';
import { interiorMenuData, InteriorMenuItem } from '../../types/interiorConfig';
function InteriorViewerContent() {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [selectedItem, setSelectedItem] = useState<InteriorMenuItem | null>(null);
  const [showSettings, setShowSettings] = useState(false);
  const [showRoomsMenu, setShowRoomsMenu] = useState(false);
  // Track the category path for the selected item
  const [currentCategory, setCurrentCategory] = useState<string>('Kitchen');
  const handleSelectItem = (item: InteriorMenuItem) => {
    setSelectedItem(item);
    // Determine category from the menu structure
    // In a real app, this would be tracked more robustly
    const findCategory = (items: InteriorMenuItem[], targetId: string, parentName?: string): string | null => {
      for (const menuItem of items) {
        if (menuItem.id === targetId) {
          return parentName || menuItem.name;
        }
        if (menuItem.children) {
          const found = findCategory(menuItem.children, targetId, menuItem.type === 'category' ? menuItem.name : parentName);
          if (found) return found;
        }
      }
      return null;
    };
    const category = findCategory(interiorMenuData, item.id) || 'General';
    setCurrentCategory(category);
  };
  const handleSelectOption = (optionId: string) => {
    console.log('Selected option:', optionId);
    // Update selected state in data (in a real app this would use a store)
    if (selectedItem && selectedItem.options) {
      // For demo purposes, we're just logging. In real app, update state.
    }
  };
  // Helper to find an item by its name
  const findItemByName = (items: InteriorMenuItem[], name: string): InteriorMenuItem | null => {
    for (const item of items) {
      if (item.name === name) return item;
      if (item.children) {
        const found = findItemByName(item.children, name);
        if (found) return found;
      }
    }
    return null;
  };
  const handleSwapSelection = (category: string, itemName: string) => {
    const item = findItemByName(interiorMenuData, itemName);
    if (item) {
      setSelectedItem(item);
      setCurrentCategory(category);
    }
  };
  const handleExit = () => {
    window.history.pushState({}, '', '/');
    window.location.href = '/';
  };
  return <div className="relative w-full h-screen overflow-hidden bg-slate-900 font-sans" data-id="element-317">
      {/* 3D Viewer Background */}
      <div className="absolute inset-0" data-id="element-318">
        <img src="https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1920&q=80" alt="Interior view" className="w-full h-full object-cover" data-id="element-319" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/60" data-id="element-320" />
      </div>

      {/* Sidebar */}
      <InteriorSidebar menuData={interiorMenuData} isCollapsed={isSidebarCollapsed} onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)} onSelectItem={handleSelectItem} selectedItemId={selectedItem?.id} data-id="element-321" />

      {/* Floating Controls */}
      <AnimatePresence data-id="element-322">
        <InteriorFloatingControls data-id="element-323" />
      </AnimatePresence>

      {/* Top Bar */}
      <InteriorTopBar onReset={() => console.log('Reset')} onControls={() => console.log('Controls')} onSettings={() => setShowSettings(true)} onExit={handleExit} data-id="element-324" />

      {/* Settings Menu */}
      <SettingsMenu isOpen={showSettings} onClose={() => setShowSettings(false)} data-id="element-325" />

      {/* Rooms Menu */}
      <RoomsMenu isOpen={showRoomsMenu} onSelect={room => {
      console.log('Teleport to:', room);
      setShowRoomsMenu(false);
    }} onClose={() => setShowRoomsMenu(false)} data-id="element-326" />

      {/* Bottom Bar */}
      <InteriorBottomBar modelName="Bellevue" customizationPercent={5} onNavigationClick={() => console.log('Navigation')} onRoomsClick={() => setShowRoomsMenu(!showRoomsMenu)} isRoomsMenuOpen={showRoomsMenu} data-id="element-327" />

      {/* Selections Widget */}
      <SelectionsWidget onSwap={handleSwapSelection} data-id="element-328" />

      {/* Options Gallery */}
      <AnimatePresence data-id="element-329">
        {selectedItem?.options && <OptionsGallery options={selectedItem.options} onSelect={handleSelectOption} onClose={() => setSelectedItem(null)} category={currentCategory} itemName={selectedItem.name} data-id="element-330" />}
      </AnimatePresence>
    </div>;
}
export function InteriorViewer() {
  return <SelectionsProvider data-id="element-331">
      <InteriorViewerContent data-id="element-332" />
    </SelectionsProvider>;
}